<template>
  <v-dialog :value="value" @input="$emit('input')" max-width="800px">
    <v-card>
      <v-card-text>
        <v-row>
          <v-col cols="6">
            <v-select
              label="Load Session"
              :items="items"
              v-model="loadSessionCode"
            />
          </v-col>
          <v-col cols="6">
            <v-btn @click="loadSession">
              <v-icon left>
                mdi-folder-open
              </v-icon>
              Load
            </v-btn>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="6">
            <v-text-field prefix="ironsworn_" label="New Session" v-model="newSessionCode" />
          </v-col>
          <v-col cols="6">
            <v-btn @click="createSession" :disabled="!newSessionCode">
              <v-icon left>
                mdi-folder-plus
              </v-icon>
              Create
            </v-btn>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12">
            <v-text-field
              readonly
              label="Current Session Code"
              v-model="sessionKey"
              hint="Copy and record this code if you're paranoid. It is used to load your session, but all your sessions on this device can also be found in the 'Load Session' dropdown."
              persistent-hint
            />
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
  import {mapGetters} from 'vuex';

  export default {
    name: 'SessionDialog',
    props: ['value'],
    components: {},
    created() {
      for (var i = 0, len = localStorage.length; i < len; i++) {
        var key = localStorage.key(i);
        // var value = localStorage[key];
        if (key.startsWith('ironsworn_')) {
          this.items.push(key);
        }
      }
    },
    watch: {
      value() {
        this.reset();
      },
    },
    computed: {
      ...mapGetters(['sessionKey']),
    },
    methods: {
      loadSession() {
        this.$router.push({query: {session: this.loadSessionCode}});
        this.$router.go();
      },
      createSession() {
        // TODO: add 'ironsworn_' to front if not included
        let key = this.newSessionCode.toLowerCase();
        if (!this.newSessionCode.startsWith('ironsworn_')) {
          key = `ironsworn_${key.toLowerCase()}`;
        }
        this.$router.push({query: {session: key}});
        this.$router.go();
      },
      close() {
        this.reset();
        this.$emit('input', false);
      },
      reset() {},
    },
    data() {
      return {
        newSessionCode: '',
        loadSessionCode: '',
        items: [],
      };
    },
  };
</script>
